export const makeWeekdayLabel = (intl, n) =>
  intl.formatMessage({ id: `common.sendDate.weekDay.${n}` });

export const makeBiWeekdayLabel = (intl, n) =>
  intl.formatMessage({ id: `common.sendDate.biWeekDay.${n}` });

export const makeMonthdayLabel = (intl, n) =>
  intl.formatMessage({ id: `common.sendDate.monthDay.${n}` });

export const weekdayMenu = (intl) =>
  Array.from({ length: 7 }, (_, i) => makeWeekdayLabel(intl, i + 1));

export const monthdayMenu = (intl) =>
  Array.from({ length: 28 }, (_, i) => makeMonthdayLabel(intl, i + 1));
